import { Component, OnInit, HostBinding } from '@angular/core';
import { ElementService, ElementDataUpdate } from '../service/element.service';
import { MatCheckboxChange, MatDialog } from '@angular/material';
import { SetParamsComponent } from './set-params/set-params.component';
import { ListParamsComponent } from './list-params/list-params.component';

export interface List {
	Value: string;
	Label: string;
}
export interface Sets {
	AdditionSet?: string;
	AdditionWhere?: string;
	BeforeSQL?: string;
}
@Component({
	selector: 'common-set-property-update',
	templateUrl: './set-property-update.component.html',
	styleUrls: ['./set-property-update.component.scss']
})
export class SetPropertyUpdateComponent implements OnInit {
	@HostBinding('class.set-property-update') hostClass = true;
	public svr = this.elementSvr.data.update as ElementDataUpdate;
	constructor(public elementSvr: ElementService, public dialog: MatDialog) {}

	selectChecked(event: MatCheckboxChange) {
		this.svr.Params.Fields.forEach(v => (v.selected = event.checked));
	}

	openSetDialog() {
		const setValue: Sets = {
			AdditionSet: this.svr.Params.AdditionSet,
			AdditionWhere: this.svr.Params.AdditionWhere,
			BeforeSQL: this.svr.Params.BeforeSQL
		};
		const setRef = this.dialog.open(SetParamsComponent, {
			width: '380px',
			height: '100%',
			data: setValue
		});

		setRef.afterClosed().subscribe(result => {
			// console.log('The setDialog was closed');
			this.svr.Params.AdditionSet = setValue.AdditionSet;
			this.svr.Params.AdditionWhere = setValue.AdditionWhere;
			this.svr.Params.BeforeSQL = setValue.BeforeSQL;
		});
	}

	openListDialog(selected: boolean, list?: List[]) {
		if (selected) {
			const listRef = this.dialog.open(ListParamsComponent, {
				width: '384px',
				height: 'calc(100% - 0px)',
				data: list,
				position: {
					right: '0',
					bottom: '0'
				}
			});

			listRef.afterClosed().subscribe(result => {
				console.log('The listDialog was closed');
			});
		}
	}

	ngOnInit() {
		this.svr.init();
	}
}
